<a
  *ngIf="(_path || _pathFx) && (_params || _paramsFx)"
  mat-menu-item
  class="action-btn p-0"
  (click)="navigateToAnotherPage(data)"
>
  <ng-content></ng-content>
</a>
